goog.provide('el8.app.shared.dialog.vipPatientAccessConfirmation');

goog.require('el8.service.urls');
goog.require('el8.template.app.shared.dialog.vipPatientAccessConfirmation');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');

/**
 * Confirm access to a VIP patient chart
 */
el8.app.shared.dialog.vipPatientAccessConfirmation = (function() {

    var pcpName = null;
    var businessName = null;

    var that = new el8.uiwidget.FormDialog({
        title: 'Accessing a VIP Patient Chart',
        modal: true,
        autoHeight: true,
        width: 400,
        testId: 'vip-authorization-dialog',
        contentFn: function() {
            return el8.template.app.shared.dialog.vipPatientAccessConfirmation.content({
                userName: el8.data.currUser.getFullName(),
                pcpName: pcpName,
                businessName: businessName,
            });
        },
    });

    var form = new el8.uiwidget.Form({
        fields: [],
        validationOpts: el8.util.validate.standardOpts
    });

    form.addButtonSane('confirm', 'Agree & Continue', function(_form) {
        $.el8_ajax({
            url: el8.service.urls.get('vipAccessConfirm'),
            type: 'POST',
            data: JSON.stringify({}),
            async: false, // Ensure the server creates our access token before we redirect
            success: function(data) {
                window.location=el8Globals['PATIENT_PATH'];
            }
        });
    }, { isPrimary: true, testId: 'vip-authorization-confirm'} );

    form.addCancelButton(function() {
        window.location=el8.service.urls.get('practiceHome');
    }, false, 'vip-authorization-cancel');

    that.setForm(form);

    var super_show = that.show;
    that.show = function(spec) {
        spec = spec || {};
        pcpName = spec.pcpName || "The primary care physician";
        businessName = spec.businessName || "this business";
        super_show.call(that);
    };

    return that;

})();
